module.exports = __webpack_public_path__ + "media/images/static/top/local/photo2_mobile-67c77da0572575b380581f339276e649.png";